import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import HTTP from "@/service/http";
import "@/assets/css/reset.css"
import "@/assets/theme/index.css"
import dateFun from "@/common/dateFun";
import commonFun from "@/common/common";
import config from "@/config";
import MetaInfo from 'vue-meta-info'
import ElementUI from 'element-ui';

Vue.config.productionTip = false
//全局HTTP
Vue.prototype.$HTTP = HTTP;
//全局方法
Vue.prototype.$transformDate = dateFun;
Vue.prototype.$commonFun = commonFun;
Vue.prototype.$config = config;
//Vue.prototype.$Notification = Notification;
/*
function setRem() {
  const baseSize = 16
  const scale = document.documentElement.clientWidth / 1200
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
setRem()
window.addEventListener('resize', setRem)
*/

// 注册文本溢出省略指令
Vue.use(ElementUI);
Vue.use(MetaInfo);

const vue = new Vue({
  router,
  store,
  render: h => h(App),
  //重要部分
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')

export default vue;
